// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // UPDATED FOR GTI ENVIRONMENT - Azure AD Configuration
  // GTI Tenant: cf4ee560-9e28-412f-b4ca-a93f404bde4e
  azureAuthenticationConfig: {
    clientId: '93e3897f-443b-4dce-8e78-b1ff2e9d2261',
    authority: 'https://login.microsoftonline.com/cf4ee560-9e28-412f-b4ca-a93f404bde4e',
    redirectUri: `${typeof window !== 'undefined' ? window.location.origin : 'https://localhost:7184'}/`,
    postLogoutRedirectUri: `${typeof window !== 'undefined' ? window.location.origin : 'https://localhost:7184'}/`,
    navigateToLoginRequestUrl: false,
    knownAuthorities: ['https://login.microsoftonline.com/cf4ee560-9e28-412f-b4ca-a93f404bde4e/'],
    get apiScope() {
      return `api://${this.clientId}/.default`;
    },
    // OpenID Connect scopes for GTI environment
    scopes: {
      openid: 'openid',
      profile: 'profile',
      email: 'email',
      userAccess: 'api://93e3897f-443b-4dce-8e78-b1ff2e9d2261/access_as_user',
      helpdesk: 'api://93e3897f-443b-4dce-8e78-b1ff2e9d2261/helpdesk',
      graph: 'api://93e3897f-443b-4dce-8e78-b1ff2e9d2261/graph',
      all: [
        'openid',
        'profile', 
        'email',
        'api://93e3897f-443b-4dce-8e78-b1ff2e9d2261/access_as_user',
        'api://93e3897f-443b-4dce-8e78-b1ff2e9d2261/helpdesk',
        'api://93e3897f-443b-4dce-8e78-b1ff2e9d2261/graph'
      ]
    }
  },

  /**
   * Base URL of restful API offered by this project's backend
   * GTI Production Environment - Direct backend URL
   */
  apiEndpoint: 'https://app-vtc-helpdesk-be-eas-uat-01.azurewebsites.net/',

  apiScopes: ['openid', 'profile', 'email'],

  

  publicHoliday: {
    filter: {
      minYear: 2022,
      maxYearOffset: 2,
    },
  },
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */